"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _default = {
  search: _propTypes.default.string.isRequired,
  offset: _propTypes.default.number.isRequired,
  length: _propTypes.default.number.isRequired,
  results: _propTypes.default.array.isRequired,
  selection: _propTypes.default.number.isRequired,
  onSelect: _propTypes.default.func.isRequired,
  onCancel: _propTypes.default.func.isRequired,
  toggleForcedOverlayFocus: _propTypes.default.func.isRequired
};
exports.default = _default;
module.exports = exports.default;